













































































































































import { computed, defineComponent, reactive, watch } from '@vue/composition-api'
import { useMachine } from 'xstate-vue2'
import { viewEditConfirmMachine } from '@/machines/viewEditConfirmMachine'
import { Document } from '@/domain/document'
import GroupHeading from '@/components/GroupHeading.vue'
import ChipBlock from '@/components/ChipBlock.vue'
import DocumentTitle from '@/components/DocumentTitle.vue'
import {
  BaseInputText,
  BaseAlert,
  BaseIcon,
  BaseButton
} from '@zucommunications/gsk-docshare-web-design-system/src/index.vue'
import DocumentStatus from '@/components/DocumentStatus.vue'
import DialogConfirm from '@/components/DialogConfirm.vue'
import OverlayLoading from '@/components/OverlayLoading.vue'
import FormAgendaDecisionCreate from '@/components/forms/FormAgendaDecisionCreate.vue'
import FormDeleteConfirm from '@/components/forms/FormDeleteConfirm.vue'
import { notEmpty } from '@/validations'
import repositoryDocument from '@/domain/documentRepository'
import DocumentChipSquare from '@/components/DocumentChipSquare.vue'
import AlertSuccess from '@/components/AlertSuccess.vue'
import AlertError from '@/components/AlertError.vue'

export default defineComponent({
  components: {
    GroupHeading,
    BaseInputText,
    DocumentStatus,
    BaseAlert,
    ChipBlock,
    BaseIcon,
    BaseButton,
    DialogConfirm,
    OverlayLoading,
    FormAgendaDecisionCreate,
    FormDeleteConfirm,
    DocumentChipSquare,
    DocumentTitle,
    AlertSuccess,
    AlertError
  },
  setup (props, { root }) {
    const store = root.$store
    const document = computed(() => store.getters['documents/getDocumentForAddin'])
    const form = reactive<Document>({
      id: undefined,
      title: ''
    })
    watch(document, () => {
      form.id = document.value.id
    }, {
      immediate: true
    })
    const { state, send } = useMachine(viewEditConfirmMachine, {
      services: {
        completing: async (context: any, event: any) => {
          const document = await repositoryDocument.minuteComplete(form as Document)
          store.commit('documents/updateDocumentInCache', document)
          return document
        },
        saving: async (context: any, event) => {
          const document = await repositoryDocument.update(form as Document)
          store.commit('documents/updateDocumentInCache', document)
          return document
        }
      }
    })
    const decisionRemove = repositoryDocument.delete
    const decisionType = computed(() => document.value.documentClass.toLowerCase().includes('yellow') ? 'Yellow' : 'Green')
    const documentSync = () => {
      repositoryDocument.findById(document.value.id).then(d => {
        store.commit('documents/addDocumentToCache', d)
      })
    }
    return {
      document,
      state,
      send,
      form,
      documentSync,
      decisionRemove,
      decisionType,
      notEmpty
    }
  }
})
